// extracted by mini-css-extract-plugin
export default {"imageContainer":"t2-z","summaryPar":"u2-z","ratingCategories":"v2-z","reviewerInfo":"w2-z","reviewTypes":"x2-z","expanded":"y2-z"};